module.exports = __webpack_public_path__ + "static/scale-model-of-yanaguana-garden-and-playground-in-san-antonio-texas-98852866989d35c19d54967a7574450f.png";